import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  loading: false,
  error: null,
}

const translationUpdateSlice = createSlice({
  name: "translationUpdate",
  initialState,
  reducers: {
    update(state) {
      state.loading = true
      state.error = null
    },
    updateCompleted(state) {
      state.loading = false
    },
    updateRejected(state, action) {
      state.loading = false
      state.error = action.payload
    },
    cleanState() {
      return initialState
    },
  },
})
/**
 * @namespace
 * @property {function} update
 *  @property {function} updateCompleted
 *  @property {function} updateRejected
 *  @property {function} cleanState
 */

export const translationUpdate = translationUpdateSlice.actions

export default translationUpdateSlice.reducer
